export default function timeStamp( value ){
    let time = new Date(value)
    let year = time.getFullYear();
    let month = time.getMonth() + 1;
    let date = time.getDate();
    let hours = time.getHours();
    let minutes = time.getMinutes();
    
    hours < 10 ? hours = '0' + hours : '';
    minutes < 10 ? minutes = '0' + minutes : '';
    
    return `${year}-${month}-${date} ${hours}:${minutes}`
}